import { Component, Inject } from '@angular/core';
import { NotificationsService } from 'src/app/services/notifications.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SendNotification } from 'src/app/layouts/full/interface/headers.interface';
import { SalesQuoteService } from 'src/app/pages/dashboards/service/sales-quote.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-accion-resolution',
  templateUrl: './modal-accion-resolution.component.html',
  styleUrl: './modal-accion-resolution.component.scss'
})
export class ModalAccionResolutionComponent {
  public comment: string = '';
  public isCommentInvalid: boolean = false;
  public load: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA)public data: any, private quoteService: SalesQuoteService, public dialogRef: MatDialogRef<ModalAccionResolutionComponent>, private notification: NotificationsService,) {

  }

  public validarComentario(action: number)  {
    if(this.comment != '') {
      this.isCommentInvalid = false;
      this.sendResolution();
    }
    else if(this.comment == '' && action==2) {
      this.comment = '-';
      this.sendResolution();
    }
    else {
      this.isCommentInvalid = true;
    }
  }

  public sendResolution() {
    this.load = true;
    const request =  {
      idCotizacion: this.data.idCotizacion,
      salesQuoteItemId: this.data.quoteItemId,
      description: this.comment || "Sin Comentario"
    };
    if(this.data.accion==1) {
      this.quoteService.rejectCotizacion(request).subscribe({
        next: (res)=> {
          this.load = false;
          //this.newAlertNotification('Descuento Rechazado');
          this.dialogRef.close(true);
        },
        error: (err)=> {
          this.load = false;
          Swal.fire({
            icon: 'error',
            text: "Ocurrio un Problema al Rechazar"
          })
        }
      });
    }
    else {
      this.quoteService.approveCotizacion(request).subscribe({
        next: (res)=> {
          this.load = false;
          //this.newAlertNotification('Descuento Aprobado');
          this.dialogRef.close(true);
        },
        error: (err)=> {
          this.load = false;
          Swal.fire({
            icon: 'error',
            text: "Ocurrio un Problema al Aprobar"
          })
        }
      });
    }
  }

  public getTitle(): string {
    switch (this.data.accion) {
      case 1:
        return 'Rechazar Descuento';
      case 2:
        return 'Aprobar Descuento';
      default:
        return 'Estado Desconocido';
    }
  }

  public newAlertNotification(action: string) {
    const request: SendNotification = {
      action: action,
      companyId: this.data.companyId,
      date: new Date(),
      userId: this.data.userId,
      type: 2,
      discount: this.data.discount,
      discountPorcent: this.data.discountPorcent,
      idType: this.data.idCotizacion
    };  
    this.notification
      .createNotifications(request)
      .subscribe((a) => console.log(a));
  }

}
